<template>
  <div class="notify">
     <p class="m-b-5">
       New data added. Refresh to get those.
     </p>
     <p>
       {{ localTime }}
     </p>
     <a href="" class="text-success" @click.prevent="refreshData">Click to Refresh</a>
  </div>
</template>

<script>
import moment from 'moment';

  export default {
     props: {
       changeData:{
         type: Function,
         default: null
       },
       utc: {
         type: String,
         default: ''
       }
     },
     methods: {
       refreshData(){
         this.changeData(true)
       }
     },
     computed: {
        localTime(){
           if(this.utc){
             const localTime  = moment.utc(this.utc).toDate();
             return moment(localTime).format('YYYY-MM-DD HH:mm:ss');
           }else{
             return '';
           }
           
        }
     }
  }
</script>

<style lang="scss" scoped>
   .notify{
      position: fixed;
      bottom: 60px;
      right: 0;
      background-color: #222f3e;
      color: #fff;
      padding: 15px;
      border-radius: 5px 0 0 5px;
   }
</style>